// Vuex Script
// Version		          : 1.0.0.0
// Template Modified Date : 14-May-2019 10:00:00 AM
// File Created Date      : 14-May-2019 10:00:00 AM
import Vue from 'vue';
import { http } from '@/shared/https';
import Axios from 'axios';

export default {
    namespaced: true,
    //#. An object containing the data
    state: {      
        card: {
            type: 'Grid'
        },
        pagination: {
            pageSize: 5
        },
        fixedHeader: true,
        hideButtons: ['Delete'],
        tempData: [],
        editedIndexArray: [],
        inlineEditor: {
            enabled: true,
            autoSave: true
        },
        actions:
        {
            updateAction: '/api/Dashboard/UpdateTooltip/'
        },
        fields: {     
            FieldName: {
                type: "TextInput",
                readonly: true,
                title: "Field Name"
            },
            Description: {
                type: "TextArea",
                width: 800,
                title: "Tooltip"
            }
        }   
    },

    //#. Used to access data from the state tree of the store
    getters: {
    },

    //#. Handler functions that perform modifications of data in the state tree
    mutations: {
        //#. fn_formCreated function
        formCreated(state, payload) {
        },

        //#. fn_formCancel function
        formCancel(state, payload) {
        },

        //#. fn_recordCreated function
        recordCreated(state, payload) {
        },

        //#. fn_recordUpdated function
        recordUpdated(state, payload) {  
        },

        //#. fn_recordDeleted function
        recordDeleted(state, payload) {
        },

        //#. fn_loadingRecords function
         loadingRecords(state, payload) {
        },
         
        //#. fn_recordsLoaded function
         recordsLoaded(state, payload) {
        }
    },

    //#. Functions that commit mutations. The main difference to Mutations is that Actions can contain asynchronous operations
    actions: {
        //#. formCreated event will be fired
        formCreated: ({ commit, rootState }, payload) => {
            commit('formCreated', { rootState, payload });
        },

        //#. formCancel event will be fired
        formCancel: ({ commit, rootState }, payload) => {
            commit('formCancel', { rootState, payload });
        },

        //#. recordAdded event will be fired
        recordCreated: ({ commit, rootState }, payload) => {
            commit('recordCreated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordUpdated: ({ commit, rootState }, payload) => {
            commit('recordUpdated', { rootState, payload });
        },

        //#. recordUpdated event will be fired
        recordDeleted: ({ commit, rootState }, payload) => {
            commit('recordDeleted', { rootState, payload });
        },
         //#. loadingRecords event will be fired
         loadingRecords: ({ commit, rootState }, payload) => {
            commit('loadingRecords', { rootState, payload });
        },
       
        //#. recordsLoaded event will be fired
        recordsLoaded: ({ commit, rootState }, payload) => {
            commit('recordsLoaded', { rootState, payload });
        },

        Update: ({ commit, rootState }, payload) => {
            //#.Tooltip editor object
            let configuration = {
                MenuId: payload.menuId,
                Controller: payload.Component,
                Records: payload.record,
                fieldName: payload.fieldName
            }

            //#.Make an Axios call to update record
            return http.post(rootState.tooltip.actions.updateAction, configuration).then(record => {
                //Check for errors
                if (record.data.Result != 'OK') {
                    record.data["operations"] = 2;
                    commit('_muCRUDNotificaion', { result: record.data }, { root: true });
                    return;
                }

                //Check for success
                if (record.data.Result == 'OK') {
                    if (!payload.record) {
                        return;
                    }

                    let tooltip = JSON.parse(payload.record),
                        field = rootState[payload.fileName].fields.find(x => x.value == payload.fieldName);

                    //#.Check for tooltip value
                    if (field.tooltip) {
                        field.tooltip = tooltip[payload.fieldName];

                        if (field.tooltip == "") {
                            let index = rootState[payload.fileName].tooltipsList.indexOf(rootState[payload.fileName].tooltipsList.find(x => x.key == field.title));
                            delete rootState[payload.fileName].tooltipsList[index];
                            rootState[payload.fileName].tooltipsList.length = rootState[payload.fileName].tooltipsList.length - 1;
                        } else {
                            rootState[payload.fileName].tooltipsList.find(x => x.key == field.title).value = field.tooltip;
                        }
                    } else {
                        //#.Add for tooltip value
                        field["tooltip"] = tooltip[payload.fieldName];
                        let index = rootState[payload.fileName].tooltipsList.length;
                        rootState[payload.fileName].tooltipsList[index] = {};
                        rootState[payload.fileName].tooltipsList[index]["key"] = field.title;
                        rootState[payload.fileName].tooltipsList[index]["value"] = field["tooltip"];
                    }

                    //#. Remove component in the DOM
                    if (rootState[payload.fileName].card.type == rootState[payload.fileName].type._form) {
                        rootState[payload.fileName].renderForm = false;

                        Vue.nextTick(() => {
                            //#. Add the component back in
                            rootState[payload.fileName].renderForm = true;
                        }); 
                    }

                    rootState.tooltip.editedIndex = null;
                    record.data["operations"] = 2;
                    commit('_muCRUDNotificaion', { result: record.data }, { root: true });
                }
            });
        }
    }
}